import { render, staticRenderFns } from "./FlvPlayer.vue?vue&type=template&id=4b68c318&scoped=true&"
import script from "./FlvPlayer.vue?vue&type=script&lang=js&"
export * from "./FlvPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b68c318",
  null
  
)

export default component.exports